import { render, staticRenderFns } from "./manageCoupon.vue?vue&type=template&id=3b31428d&"
import script from "./manageCoupon.vue?vue&type=script&lang=js&"
export * from "./manageCoupon.vue?vue&type=script&lang=js&"
import style0 from "./manageCoupon.vue?vue&type=style&index=0&id=3b31428d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports